jQuery(document).ready(function($) {
   
    var OSName="Unknown OS";
    if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows";
    if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS";
    if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
    if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux";
    //Windows
    console.log(OSName)
    if (navigator.appVersion.indexOf("Win") != -1){
        // console.log('fsdfsd')
        jQuery('body').addClass('win');
        console.log('12345')
      // document.getElementsByTagName("body")[0].classList.add("win");  
    }
    //Mac
    else if (navigator.appVersion.indexOf("Mac") != -1){
        jQuery('body').addClass('mac');
      // document.getElementsByTagName("body")[0].classList.add("mac");
    }
    else if (navigator.appVersion.indexOf("X11") != -1){
        jQuery('body').addClass('UNIX');
      // document.getElementsByTagName("body")[0].classList.add("UNIX");
    }
    else if (navigator.appVersion.indexOf("Linux") != -1){
        jQuery('body').addClass('Linux');
      // document.getElementsByTagName("body")[0].classList.add("Linux");
    }
    $owlCarousel = $(".footer_top .owl-carousel").owlCarousel({
        loop:true,
        margin:10,
        nav:false,
        autoplay:true,
        // autoplayTimeout:2000,
        autoplayHoverPause:true,
        dots:false,
        // center:true,
        slideTransition: 'linear',
        autoplayTimeout: 3000,
        autoplaySpeed: 3000,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:2
            },
            1140:{
                items:3
            },
            1450:{
                items:4
            }
        }
    });
  
     $owlCarousel = $(".icon-slider.owl-carousel").owlCarousel({
        loop:true,
        margin:15,
        nav:false,
        autoplay:true,
        // autoplayTimeout:2000,
        autoplayHoverPause:true,
        dots:false,
        // center:true,
        slideTransition: 'linear',
        autoplayTimeout: 3000,
        autoplaySpeed: 3000,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:2
            },
            1140:{
                items:3
            },
            1350:{
                items:4
            }
        }
    });
  $owlCarousel1 = $(".collection_owl_carousel .owl-carousel").owlCarousel({
        loop:true,
        margin:10,
        nav:false,
        autoplay:true,
        slideTransition: 'linear',
        autoplayTimeout: 3000,
        autoplaySpeed: 3000,
        autoplayHoverPause:true,
        dots:false,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:2
            },
            1140:{
                items:3
            },
            1450:{
                items:4
            }
        }
    });
  if (jQuery('.best_sellers .gallery-cell').length){
      jQuery('.best_sellers .gallery-cell').each(function(){
          thumbnail__title = jQuery(this).find('.product-thumbnail__title').html();
          if(thumbnail__title != '' && thumbnail__title != undefined){
            thumbnail__title_arr = thumbnail__title.split("Titanium");
            if(thumbnail__title_arr.length > 1){
              if(thumbnail__title_arr.length){
                jQuery(this).find('.product-thumbnail__title').html(thumbnail__title_arr[0])
              }
              if(thumbnail__title_arr[1]){
                jQuery(this).find('.product-thumbnail__title').after('<p class="product-thumbnail__sub-title">Titanium '+thumbnail__title_arr[1]+'</p>');
              }  
            }else{
              thumbnail__title_arr = thumbnail__title.split("Compound");
               if(thumbnail__title_arr.length > 1){
                 if(thumbnail__title_arr.length){
                  jQuery(this).find('.product-thumbnail__title').html(thumbnail__title_arr[0])
                }
                if(thumbnail__title_arr[1]){
                  jQuery(this).find('.product-thumbnail__title').after('<p class="product-thumbnail__sub-title">Compound '+thumbnail__title_arr[1]+'</p>');
                }  
               }else{
                 thumbnail__title_arr = thumbnail__title.split("Brass");
                 if(thumbnail__title_arr.length > 1){
                   if(thumbnail__title_arr.length){
                    jQuery(this).find('.product-thumbnail__title').html(thumbnail__title_arr[0])
                  }
                  if(thumbnail__title_arr[1]){
                    jQuery(this).find('.product-thumbnail__title').after('<p class="product-thumbnail__sub-title">Brass '+thumbnail__title_arr[1]+'</p>');
                  }  
                 }else{
                   thumbnail__title_arr = thumbnail__title.split("Spring");
                   if(thumbnail__title_arr.length > 1){
                     if(thumbnail__title_arr.length){
                      jQuery(this).find('.product-thumbnail__title').html(thumbnail__title_arr[0])
                    }
                    if(thumbnail__title_arr[1]){
                      jQuery(this).find('.product-thumbnail__title').after('<p class="product-thumbnail__sub-title">Spring '+thumbnail__title_arr[1]+'</p>');
                    }  
                   }else{
                     thumbnail__title_arr = thumbnail__title.split("Washers");
                     if(thumbnail__title_arr.length > 1){
                       if(thumbnail__title_arr.length){
                        jQuery(this).find('.product-thumbnail__title').html(thumbnail__title_arr[0])
                      }
                      if(thumbnail__title_arr[1]){
                        jQuery(this).find('.product-thumbnail__title').after('<p class="product-thumbnail__sub-title">Washers '+thumbnail__title_arr[1]+'</p>');
                      }  
                     }
                   }
                 }
               }
            }   
          }
      });
      

  }

  if (jQuery('.category_collection_list .product__grid-item').length){
      jQuery('.category_collection_list .product__grid-item').each(function(){
          thumbnail__title = jQuery(this).find('.product-thumbnail__title').html();
          if(thumbnail__title != '' && thumbnail__title != undefined){
            thumbnail__title_arr = thumbnail__title.split("Titanium");
            if(thumbnail__title_arr.length > 1){
              if(thumbnail__title_arr.length){
                jQuery(this).find('.product-thumbnail__title').html(thumbnail__title_arr[0])
              }
              if(thumbnail__title_arr[1]){
                jQuery(this).find('.product-thumbnail__title').after('<p class="product-thumbnail__sub-title">Titanium '+thumbnail__title_arr[1]+'</p>');
              }  
            }
          }
      });
  }
  setTimeout( function() {
  if (jQuery('.single_related_product .gallery-cell').length){
      jQuery('.single_related_product .gallery-cell').each(function(){
          thumbnail__title = jQuery(this).find('.product-thumbnail__title').html();
        // console.log(thumbnail__title)
          if(thumbnail__title != '' && thumbnail__title != undefined){
            thumbnail__title_arr = thumbnail__title.split("Titanium");
            if(thumbnail__title_arr.length > 1){
              if(thumbnail__title_arr.length){
                jQuery(this).find('.product-thumbnail__title').html(thumbnail__title_arr[0])
              }
              if(thumbnail__title_arr[1]){
                jQuery(this).find('.product-thumbnail__title').after('<p class="product-thumbnail__sub-title">Titanium '+thumbnail__title_arr[1]+'</p>');
              }  
            }
          }
      });
  } },2000);

  // setTimeout( function() {
  // if (jQuery('.ajax-cart__list .ajax-cart__product').length){
  //     jQuery('.ajax-cart__list').each(function(){
  //         thumbnail__title = jQuery(this).find('.ajax-cart__product-title a').html();
  //       console.log(thumbnail__title)
  //         if(thumbnail__title != '' && thumbnail__title != undefined){
  //           thumbnail__title_arr = thumbnail__title.split("Titanium");
  //           if(thumbnail__title_arr.length > 1){
  //             if(thumbnail__title_arr.length){
  //               jQuery(this).find('.ajax-cart__product-title a').html(thumbnail__title_arr[0])
  //             }
  //             if(thumbnail__title_arr[1]){
  //               jQuery(this).find('.ajax-cart__product-title a').after('<p class="ajax-cart__product_sub-title">Titanium '+thumbnail__title_arr[1]+'</p>');
  //             }  
  //           }
  //         }
  //     });
  // } },2000);
  
  if ( $(window).width() < 998 ) {
    if($('.best_sellers .featured-collection__title a').length){
      $('.best_sellers .featured-collection__title a').html(function(){
          return $(this).html().replace('Our','Our<br/>');
      });
    }
    $('.reviews .review-row.owl-carousel').owlCarousel({
      loop:true,
        margin:10,
        nav:false,
        autoplay:false,
        autoplayTimeout:2000,
        autoplayHoverPause:false,
        
        dots:false,
        responsive:{
            0:{
                items:1,
                stagePadding: 30,
            },
            600:{
                items:1
            },
            820:{
                items:2
            },
            1000:{
                items:2
            }
        }
      
    });
    $('.product-main-content.review-row.owl-carousel').owlCarousel({
      loop:true,
        margin:20,
        nav:false,
        autoplay:false,
        autoplayTimeout:2000,
        autoplayHoverPause:false,
        dots:false,
        stagePadding: 50,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            820:{
                items:2
            },
            1000:{
                items:2
            }
        }
      
    });

    $('.product-gallery__thumbnails.owl-carousel').owlCarousel({
        loop:false,
        margin:5,
        nav:false,
        autoplay:false,
        autoplayTimeout:2000,
        autoplayHoverPause:false,
        dots:false,
        responsive:{
            0:{
                items:4
            },
            600:{
                items:4
            },
            1000:{
                items:4
            }
        }
    });
    $('.product-gallery__thumbnails.owl-carousel').on('click', '.owl-item', function (e) {
          // alert('click');
      owlIndex = $(this).index();

      var carousel = $('.product-gallery__thumbnails.owl-carousel').data('owl.carousel');
        e.preventDefault();
        carousel.to(carousel.relative($(this).index()));
      owlIndex = (carousel.relative($(this).index()));
      console.log(owlIndex)
      // if(owlIndex != undefined){
      //   owlIndex = owlIndex + 1;
      // }
      $(".single_product_details .flickity-slider .product-gallery__image").removeClass('is-selected')
      $(".single_product_details .flickity-slider .product-gallery__image").each(function(key,val){
        // console.log(key) 
        // console.log(owlIndex) 
        if(key == owlIndex){
           $(".single_product_details .flickity-slider").css({transform: "translateX(-200%)"});;
            $(this).addClass('is-selected');
              console.log('test')
              // owlIndex = owlIndex + 1;
             
            
          }else{
            $(this).removeClass('is-selected');
          }
      });
      
      // console.log($(this).find('.product-gallery__thumbnail img').attr('src'));
  })
  }
  $(window).on('resize', function(){
    $owlCarousel.trigger('refresh.owl.carousel');
    $owlCarousel1.trigger('refresh.owl.carousel');
      // var win = $(this); //this = window
      // if (win.height() >= 820) { /* ... */ }
      // if (win.width() >= 1280) { /* ... */ }
     var highest = null;
        var hi = 0;
    $(".best_sellers .gallery-cell .product-thumbnail").css('min-height','100%');
    if (jQuery('.best_sellers .gallery-cell').length){
        $(".best_sellers .gallery-cell").each(function(){
          var h = $(this).find('.product-thumbnail').outerHeight();
          // console.log(h)
          if(h > hi){
             hi = h;
             highest = $(this);  
          }    
        });
    }
    if(hi > 0){
      hi = hi + 5;
      $(".best_sellers .gallery-cell .product-thumbnail").css('min-height',hi+'px');
    }else{
      $(".best_sellers .gallery-cell .product-thumbnail").css('min-height','100px');
    }
    
    // console.log(hi)
    review_row_description_height();
    setTimeout( function() {
        related_product_break_line();
        relate_product_height();
      
      },2000);
  });
 $(window).on('load', function(){
        var hi = 0;
      $(".best_sellers .gallery-cell .product-thumbnail").css('min-height','100%');
      if (jQuery('.best_sellers .gallery-cell').length){
          $(".best_sellers .gallery-cell").each(function(){
            var h = $(this).find('.product-thumbnail').outerHeight();
            console.log(h)
            if(h > hi){
               hi = h;
              
            }    
          });
      }
      if(hi > 0){
        hi = hi + 5;
        $(".best_sellers .gallery-cell .product-thumbnail").css('min-height',hi+'px');
      }else{
        $(".best_sellers .gallery-cell .product-thumbnail").css('min-height','100px');
      }
     review_row_description_height();
    setTimeout( function() {
      related_product_break_line();
        relate_product_height();
        
      },2000);
  });

  function review_row_description_height(){
     var screen_width = jQuery(window).width();
     if (screen_width >= 320){
        var review_height = 0;
        if (jQuery('.review-row .review-item').length){
          $(".review-row .review-item .description").css('min-height','150px');
            $(".review-row .review-item").each(function(){
              var rh = $(this).find('.description').outerHeight();
              // console.log(rh)
              if(rh > review_height){
                 review_height = rh;
                  
              }    
            });
        }
        if(review_height > 0){
          review_height = review_height + 10;
          $(".review-row .review-item .description").css('min-height',review_height+'px');
        }else{
          $(".review-row .review-item .description").css('min-height','150px');
        }
     }else{
       $(".review-row .review-item .description").css('min-height','auto');
     }
  }

  function relate_product_height(){
     var screen_width = jQuery(window).width();
     // if (screen_width > 768){
        var review_height = 0;
        if (jQuery('.product-recommendations .gallery-cell').length){
          $(".product-recommendations .gallery-cell .product-thumbnail").css('min-height','100px');
            $(".product-recommendations .gallery-cell").each(function(){
              var rh = $(this).find('.product-thumbnail').outerHeight();
              // console.log(rh)
              if(rh > review_height){
                 review_height = rh;
                  
              }    
            });
        }
        if(review_height > 0){
          review_height = review_height + 5;
          $(".product-recommendations .gallery-cell .product-thumbnail").css('min-height',review_height+'px');
        }else{
          $(".product-recommendations .gallery-cell .product-thumbnail").css('min-height','100px');
        }
     // }else{
     //   $(".product-recommendations .gallery-cell .product-thumbnail").css('min-height','auto');
     // }
  }

  function related_product_break_line(){
    if (jQuery('.product-recommendations .gallery-cell').length){
        jQuery('.product-recommendations .gallery-cell').each(function(){
            thumbnail__title = jQuery(this).find('.product-thumbnail__title').html();
          console.log(thumbnail__title)
            if(thumbnail__title != '' && thumbnail__title != undefined){
              thumbnail__title_arr = thumbnail__title.split("Titanium");
              if(thumbnail__title_arr.length > 1){
                if(thumbnail__title_arr.length){
                  jQuery(this).find('.product-thumbnail__title').html(thumbnail__title_arr[0])
                }
                if(thumbnail__title_arr[1]){
                  jQuery(this).find('.product-thumbnail__title').after('<p class="product-thumbnail__sub-title">Titanium '+thumbnail__title_arr[1]+'</p>');
                }  
              }
            }
        });
    }
  }
  var acc = document.getElementsByClassName("accordion");
  var i;
  
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
  
  /* Community page jquery */
  jQuery('#load-more').on('click', function() {
    jQuery('.review-row.box-container').find('.box:not(.show)').each(function(ix) {
      jQuery(this).addClass('show');
      return ix < 5;
    });
    if(jQuery('.review-row.box-container').find('.box:not(.show)').length <= 0) {
        jQuery('#load-more').css('display', 'none');
    }
  });
  if(jQuery('#community .review-main-container .review-item').length <= 6) {
    jQuery('#load-more').css('display', 'none');
  }

  const updateCartValueOnUpdate = function(item) {
    // TODO: After verify Need to delete from line no. 502 To 517
   //  if (jQuery('.styles_CartPreview__empty__WFP86').length){
   //    if(!jQuery('.styles_CartPreview__empty__WFP86 .empty_show_now').length){
   //      $(".styles_CartPreview__empty__WFP86 h3").after('<a href="/collections/all" class="empty_show_now">SHOP NOW</a>');
   //    }
   //    jQuery('#CartPopup .upcart-header-text').text('YOUR CART');
   // }else{
   //   jQuery('#CartPopup .upcart-header-text').text('IN YOUR SHOPPING CART');
   // }
    // if(jQuery('#subTotalCart').length > 0) {
    //   let splitArr = jQuery('a.upcart-checkout-button').html().split('-');
    //   if(splitArr.length > 1) {
    //     jQuery('#subTotalCart').empty().html(splitArr[1].trim());
    //     jQuery('a.upcart-checkout-button').html('PROCEED TO CHECKOUT');
    //   }
    // }
    
    // To show subtotal of the slider cart
    if(item && item.item_count > 0) {
      jQuery('#CartPopup .upcart-header-text').text('IN YOUR SHOPPING CART');
      setTimeout(function() {
        jQuery('#subTotalCart').empty().html('$' + (item.items_subtotal_price / 100).toFixed(2));
        jQuery('a.upcart-checkout-button').html('PROCEED TO CHECKOUT');
      }, 5);
    } else {
      jQuery('#CartPopup .upcart-header-text').text('YOUR CART');
      $(".styles_CartPreview__empty__WFP86 h3").after('<a href="/collections/all" class="empty_show_now">SHOP NOW</a>');
    }
    
  }

  // TODO: Comment this function due to ios issue
   setTimeout(function() {
     window.upcartModifyCart = function(item) {
      updateCartValueOnUpdate(item);
    };
    
    // TODO: After verify Need to delete from line no. 542 To 547
    // document.querySelector('#CartPopup .UpcartDesignSettings__button.upcart-checkout-button').addEventListener("input", function (event) {
    //   console.error('SOMETHING HAPPEN');
    //   updateCartValueOnUpdate();
    //   // empty_cart_button();
    // }, false);
  }, 500);
  


});
 
// jQuery(document).on('click','.header-cart .header__link',function(){
  
//   $(".styles_CartPreview__empty__WFP86 h3").after('<a href="/collections/all" class="empty_show_now">SHOP NOW</a>');
// });
jQuery( window ).on("load", function() {
       $(".styles_CartPreview__empty__WFP86 .empty_show_now").remove();
  $(".styles_CartPreview__empty__WFP86 h3").after('<a href="/collections/all" class="empty_show_now">SHOP NOW</a>');
   if (jQuery('.styles_CartPreview__empty__WFP86').length){
      jQuery('#CartPopup .upcart-header-text').text('YOUR CART');
   }else{
     jQuery('#CartPopup .upcart-header-text').text('IN YOUR SHOPPING CART');
   }
});

function empty_cart_button(){
   
   if (jQuery('.styles_CartPreview__empty__WFP86').length){
       $(".styles_CartPreview__empty__WFP86 .empty_show_now").remove();
      $(".styles_CartPreview__empty__WFP86 h3").after('<a href="/collections/all" class="empty_show_now">SHOP NOW</a>');
      jQuery('#CartPopup .upcart-header-text').text('YOUR CART');
   }else{
     jQuery('#CartPopup .upcart-header-text').text('IN YOUR SHOPPING CART');
   }
}
jQuery(function(){
 empty_cart_button();
// $(document).ready(function() {
     var screen_width = jQuery(window).width();
     if (screen_width > 1024){
        jQuery('.logo-slider').slick({
            speed: 10000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            arrows: false,  
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: true
       });
     } else if (screen_width > 580) {
       	jQuery('.logo-slider').slick({
              speed: 10000,
              autoplay: true,
              autoplaySpeed: 0,
              cssEase: 'linear',
              arrows: false,  
              slidesToShow: 4,
              slidesToScroll: 1,
              variableWidth: true
         });
     } else {
     	jQuery('.logo-slider').slick({
            speed: 10000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            arrows: false,  
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: true
       });
     }
  });